export enum AgreementType {
  AMEX = 'AMEX',
  CEG = 'CEG',
  TDW_TERMS_AND_CONDITIONS = 'TDW_TERMS_AND_CONDITIONS',
  TDW_TERMS_AND_CONDITIONS_LITE = 'TDW_TERMS_AND_CONDITIONS_LITE',
  ME = 'ME',
  NASDAQ = 'NASDAQ',
  NYSE = 'NYSE',
  OPRA = 'OPRA',
  USOTC = 'USOTC',
  LSEGRU = 'LSEGRU',
  CMSPDJ = 'CMSPDJ',
  IEX = 'IEX',
  STOCK_LENDING = 'STOCK_LENDING' // Stock Lending agreement status is not retrieved from the same backend call
}

export enum AgreementStatus {
  ACCEPTED = 'ACCEPTED',
  UNSIGNED = 'UNSIGNED'
}
